import "./index.css";
import { useRef, useState } from "react";
import { useAuth } from "@clerk/clerk-react";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { queryClient } from "./frontend";
import type { RouterContext } from "./routes/__root";

type AppRouter = ReturnType<typeof createAppRouter>;

function createAppRouter(
  getTokenRef: React.RefObject<RouterContext["getToken"]>,
) {
  return createRouter({
    routeTree,
    context: {
      queryClient,
      getToken: (...args) => getTokenRef.current(...args),
    } satisfies RouterContext,
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
}

export function App() {
  const { getToken } = useAuth();
  const getTokenRef = useRef(getToken);
  getTokenRef.current = getToken;

  const [router] = useState(() => createAppRouter(getTokenRef));

  return <RouterProvider router={router} />;
}

export default App;
